import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import OrderReportIndex from "../../../../components/SidetabPages/Report/Bookings/OrderReportIndex";

const OrderReport = () => {
  return (
    <>
      <AnnouncementBar />
      <OrderReportIndex />
    </>
  );
};
export default OrderReport;
